export const SLAVE_AVAILABLE = 'iosBridge/SLAVE_AVAILABLE';
export const TIPPING_DONE = 'iosBridge/TIPPING_DONE';
export const CLOSE_TIP_SCREEN = 'iosBridge/CLOSE_TIP_SCREEN';

export const READER_TRANSACTION_SUCCESS = 'iosBridge/READER_TRANSACTION_SUCCESS';
export const READER_TRANSACTION_FAIL = 'iosBridge/READER_TRANSACTION_FAIL';

export const HIDE_RECEIPT = 'iosBridge/HIDE_RECEIPT';

export const OPEN_CASH_DRAWER = 'iosBridge/OPEN_CASH_DRAWER';

export const STRIPE_CONNECT_TOKEN = 'iosBridge/STRIPE_CONNECT_TOKEN';

export const REGISTER_PAYMENT_HANDLER = 'iosBridge/REGISTER_PAYMENT_HANDLER';

export const HANDOFF = 'iosBridge/HANDOFF';
export const HANDOFF_UPDATE_KIOSK_CART = 'iosBridge/UPDATE_KIOSK_CART';
export const HANDOFF_RESET_KIOSK_CART = 'iosBridge/RESET_KIOSK_CART';
export const HANDOFF_BUSY = 'iosBridge/HANDOFF_BUSY';
export const HANDOFF_ERROR = 'iosBridge/HANDOFF_ERROR';
export const HANDOFF_SUCCESS = 'iosBridge/HANDOFF_SUCCESS';

export const SHOW_MESSAGE = 'iosBridge/SHOW_MESSAGE';
